<template>
    <path d="M976.452 247.543c20.798-20.798 20.798-55.468 0-75.196l-124.794-124.794c-19.732-20.798-54.398-20.798-75.194 0l-98.132 97.598 199.996 199.996 98.13-97.598zM31.948 792.058v199.996h199.996l589.856-590.383-199.998-199.996-589.854 590.383z"></path>
</template>